import $ from 'jquery';

export default function responsiveIframe() {
    let $iframe = $('.content-pane').find('iframe').not('.c-video__holder iframe');

    $iframe.wrap('<div class="c-responsive-iframe" />');
}